import { Group as MantineGroup } from "@mantine/core";

export const Group = MantineGroup;
